/* Carriles */

export const consultarCarriles = (filtros, paginationMode) => ({
    url: `carriles`,
    method: 'GET',
    params: {
        ...filtros,
        page: paginationMode ? paginationMode.page : null,
        size: paginationMode ? paginationMode.pageSize : null,
    }
})

export const consultarCarril = (carrilId) => ({
    url: `carriles/${carrilId}`,
    method: 'GET',
})

export const consultarRegistrosCarril = (carrilId, filtros, paginationMode) => ({
    url: `carriles/${carrilId}/eventos`,
    method: 'GET',
    params: {
        ...filtros,
        page: paginationMode ? paginationMode.page : null,
        size: paginationMode ? paginationMode.pageSize : null,
    }
})

export const cambiarEstatusCarril = (carrilId, accion) => ({
    url: `carriles/${carrilId}`,
    method: 'POST',
    data: {
        accion
    }
})

export const cambiarSentidoCarril = (carrilId) => ({
    url: `carriles/${carrilId}`,
    method: 'POST',
    data: {
        accion: 'INVERTIR'
    }
})

/* Tags */

export const consultarTag = (prefijo, numero) => ({
    url: `tags/${prefijo}/${numero}`,
    method: 'GET',
})


export const consultarRegistrosTag = (prefijo, numero, filtros, paginationMode) => ({
    url: `tags/${prefijo}/${numero}/eventos`,
    method: 'GET',
    params: {
        ...filtros,
        page: paginationMode ? paginationMode.page : null,
        size: paginationMode ? paginationMode.pageSize : null,
    }
})

/* Acciones */

export const registrarIncidencia = (data) => ({
    url: `estancias`,
    method: 'POST',
    data: {
        ...data,
        accion: 'incidencia'
    }
})

export const cerrarEstanciaPension = (data) => ({
    url: `estancias`,
    method: 'POST',
    data: {
        ...data,
        accion: 'cerrar'
    }
})

export const aperturaManual = (data) => ({
    url: `tags`,
    method: 'POST',
    data
})


/* Estancias */

export const consultarEstancia = (estanciaId) => ({
    url: `estancias/${estanciaId}`,
    method: 'GET',
})

export const consultarEstanciasAbiertas = (filtros, paginationMode) => ({
    url: `estancias`,
    method: 'GET',
    params: {
        ...filtros,
        page: paginationMode ? paginationMode.page : null,
        size: paginationMode ? paginationMode.pageSize : null,
    }
})

/* Simulador */

export const enviarComando = (data) => ({
    url: `test/comandos`,
    method: 'POST',
    data
})